var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrosoft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 14.5H28V4.23333C28 3.82853 27.6416 3.5 27.2 3.5H16V14.5Z",
    fill: "#4CAF50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 14.5V3.5H3.8C3.3584 3.5 3 3.82853 3 4.23333V14.5H15Z",
    fill: "#F44336"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 16.5H3V27.7C3 28.1416 3.3584 28.5 3.8 28.5H15V16.5Z",
    fill: "#2196F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16.5V28.5H27.2C27.6416 28.5 28 28.1416 28 27.7V16.5H16Z",
    fill: "#FFC107"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoft);
export default __webpack_public_path__ + "static/media/microsoft.eab78605fa14bcecbdcfe5a08b1dabf7.svg";
export { ForwardRef as ReactComponent };